import { render, staticRenderFns } from "./requestsPerCostCenter.vue?vue&type=template&id=623f4666&scoped=true"
import script from "./requestsPerCostCenter.vue?vue&type=script&lang=js"
export * from "./requestsPerCostCenter.vue?vue&type=script&lang=js"
import style0 from "./requestsPerCostCenter.vue?vue&type=style&index=0&id=623f4666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f4666",
  null
  
)

export default component.exports